
export default {
    computed: {
        isBlogPage() {
            return this.cmsPageState?.currentPage?.type ?? '' === 'cms_blog';
        },
    },

    methods: {
        createdComponent() {
            this.initElementConfig('acris-blog-title');

            if (!this.isBlogPage || this.element?.translated?.config?.content) {
                return;
            }

            if (this.element.config.content.source && this.element.config.content.value) {
                return;
            }

            this.element.config.content.source = 'mapped';
            this.element.config.content.value = 'acris_blog.title';
        }
    }
};